import ModalSymptoms from "./ModalSymptoms";

export default ModalSymptoms;